module.exports = __webpack_public_path__ + "static/tiamat_alt_mtg_afr-1c02408a422940c698afa064e5ca8afd.jpg";